import React, { useContext, useEffect, useRef, useState } from "react";
import Context from "../../context";
import anime from "animejs/lib/anime.es.js";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion"
import { media } from "styled-bootstrap-grid";

import useResizeObserver from '../../hooks/use-resize-observer'
import { spanFerkel } from "../../utils.js";
import TypoAnimation, { addTypoAnimation } from "../typo-animation";
import Button from "./../button";

const IntroductionButton = styled(Button)`
  position: fixed;
  bottom: 2rem;
  left: 50%;
	transform: translateX(-50%);
	transition: transform .4s ease-in-out;
	margin-right: 0px;
	z-index: 2000;

	${media.md`
		right: 2rem;
		left: auto;
		transform: none;
	`}
`
const IntroSkipButton = motion(IntroductionButton)

const Intro = ({holeWidth}) => {
	const context = useContext(Context);
	const [ showSkipButton, setSkipButton ] = useState(true)
	let timeline = useRef(null)
  let textWrapper;

  useEffect(() => {
    textWrapper = document.querySelectorAll(".animatedText");
    textWrapper.forEach((el) => {
			el.innerHTML = spanFerkel(el.textContent);
  	});

		timeline.current = anime.timeline({ loop: false });
		timeline.current.add(
			{
				targets: ".introContent--01 .introHeadline span",
				translateY: [20, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1200,
				delay: (el, i) => 300 + 30 * i,
			},
				"+=1000"
			)
      .add(
        {
          targets: ".introContent--01 .introCopy span",
          translateY: [20, 0],
					opacity: [0, 1],
					easing: "easeOutExpo",
					duration: 1000,
					delay: (el, i) => 300 + 20 * i,
        },
         "-=1400"
      )
      .add(
        {
          targets: ".introContent--01 .introHeadline span",
          translateY: [0, -20],
          opacity: [1, 0],
          easing: "easeInExpo",
          duration: 1200,
          delay: (el, i) => 100 + 30 * i,
        },
         "+=1000"
      )
      .add(
        {
          targets: ".introContent--01 .introCopy",
          translateY: [0, -20],
          opacity: [1, 0],
          easing: "easeInExpo",
          duration: 1200,
        },
         "-=1400"
      );

    addTypoAnimation(timeline.current, context);

    timeline.current.add({
      targets: ".introContent--03 .introCopy span",
      translateY: [20, 0],
      opacity: [0, 1],
      easing: "easeOutExpo",
      duration: 1000,
      delay: (el, i) => 300 + 20 * i,
    })
		.add({
			targets: ".introContent--03 .introButton",
			translateY: [20, 0],
			opacity: [0, 1],
			easing: "easeOutExpo",
			duration: 500,
			begin: () => {
				setSkipButton(false)
			}
		})
  }, []);

  return (
    <>
			<AnimatePresence>
				{ showSkipButton &&
					<IntroSkipButton
						key="introSkip"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1, transition: { delay: 2 } }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.2 }}
						to={`#`}
						text={`Intro überspringen`}
						color={'white'}
						backgroundcolor={'black'}
						className={'introSkip'}
						handleClick={(event) => {
							event.preventDefault();
							if (timeline.current) timeline.current.pause();
							context.onTriggerGridAnimation("complete");
						}}
					/>
				}
			</AnimatePresence>
      <div className="introWrapper" style={{width: context.currentAnimationState ? `${holeWidth - 20}px` : '100%'}}>
        <div className="introContent introContent--01">
          <h2 className="introHeadline animatedText">
            Jahresbericht 2020 Baden-Württemberg Stiftung
          </h2>
          <p className="introCopy animatedText" style={{padding: '0 24px'}}>
						Wir leben in einer besonderen Zeit. Corona hat nicht nur unser Leben verändert — das mikroskopisch kleine Virus hat auch unseren Fortschrittsglauben und das Weiter-so infrage gestellt.
          </p>
        </div>
        <div className="introContent introContent--02">
          <TypoAnimation />
        </div>
        <div className="introContent introContent--03">
					<h5 className="introCopy -bold animatedText" style={{margin: '0 auto'}}>STOP. START. WEITER. Zurück auf Los!</h5>
					<p className="introCopy animatedText" style={{margin: '0 auto 2em'}}>
						lautet daher das Leitmotiv unseres Jahresberichts 2020. Denn die Pandemie markiert eine Zäsur in unserer Zeitrechnung. Wir haben mit Menschen aus unseren Programmen gesprochen und gefragt: Womit möchten wir in Zukunft aufhören, womit endlich beginnen, und womit möchten wir weitermachen?
					</p>
					<Button
						to={`#`}
						text={`Entdecken`}
						color={'white'}
						backgroundcolor={'black'}
						className={'introButton'}
						handleClick={(event) => {
							event.preventDefault();
              context.onTriggerGridAnimation("complete");
						}}
					></Button>
        </div>
      </div>
    </>
  );
};

export default Intro;
